module.exports = __webpack_public_path__ + "img/cert-wall.723f05a1.webp";